import nav from './nav';
import home from './home';
import products from './products';
import about from './about';
import news from './news';
import contact from './contact';
import footer from './footer';
import userguide from './userguide';
import faq from './faq';
import en from './en';
import zh from './zh';

// 合并所有翻译
export const messages = {
  en: {
    // 通用系统文案
    ...en,
    // 模块特定文案
    nav: nav.en,
    home: home.en,
    products: products.en,
    about: about.en,
    news: news.en,
    contact: contact.en,
    userguide: userguide.en,
    faq: faq.en,
    // footer 相关翻译
    footer: footer.en
  },
  zh: {
    // 通用系统文案
    ...zh,
    // 模块特定文案
    nav: nav.zh,
    home: home.zh,
    products: products.zh,
    about: about.zh,
    news: news.zh,
    contact: contact.zh,
    userguide: userguide.zh,
    faq: faq.zh,
    // footer 相关翻译
    footer: footer.zh
  },
  // 其他语言保持不变
  fr: {
    // 通用系统文案 (使用英文作为基础)
    ...en,
    // 修改语言特定文案
    language: 'Français',
    // 模块特定文案
    nav: nav.en,
    home: home.en,
    products: products.en,
    about: about.en,
    news: news.en,
    contact: contact.en,
    userguide: userguide.en,
    faq: faq.en,
    footer: footer.en
  }
  // 其他语言配置可按需添加
}; 